<template>
  <div>
    <el-select size="mini" :value="ids" collapse-tags @change="onChange" multiple filterable placeholder="请选择费项">
      <el-option
        v-for="item in list"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
    <el-button size="mini" @click="all">全选</el-button>
    <el-button size="mini" @click="notAll">不选</el-button>
  </div>
</template>

<script>

export default {
  name: "selectChargeItemName",
  props:{
    Ids:{
      type:Array,
      default(){
        return []
      }
    }
  },
  data(){
    return{
      list:[],
      ids:[],
    }
  },
  model:{
    prop:"Ids",
    event:"onChange"
  },
  mounted() {
    this.getProjectList();
  },
  methods:{
    getProjectList(){
      console.log("getProjectList")
      const that=this;
      ERP.getRequest({url:"admin/HouseChargeitemName/getHouseChargeitemNameList",data:{}},ret=>{
        console.log(ret);
        if(ret.code){
          that.list=ret.data;
        }else {
          that.$message.error("请求异常")
        }
      })
    },
    onChange(ids){
      this.ids=ids;
      this.$emit("onChange",this.ids)
    },
    all(){
      this.onChange(this.list.map(ret=>ret.id))
    },
    notAll(){
      this.onChange([])
    }
  },
  watch:{
    Ids(n){
      this.ids=n;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/components/common/selectChargeItemName.vue